import { apiUrl, getTelUrl, zhikeUrl } from 'common/config';

export const postAnswer = ['post', `${apiUrl}/answer`];
export const getUploadSignature = ['get', 'https://api.smartstudy.com/file/upload/signature'];
export const postCorrectionImage = ['post', 'https://api.smartstudy.com/api/v2/correction'];
export const postCorrection = ['post', `${apiUrl}/correction`];
export const postExercise = ['post', `${apiUrl}/exercise`];
export const getReport = ['get', `${apiUrl}/report/@mode`];
export const postCorrect = ['post', `${apiUrl}/manual-pigai/submit`];
export const postComplete = ['post', `${apiUrl}/exercises/complete`];
export const getExerciseList = ['get', `${apiUrl}/exercises/last-test`];
export const postMachinePigai = ['post', `${apiUrl}/machine-pigai/@subject/submit`];
export const getSpeakingMachinePigai = ['get', `${apiUrl}/machine-pigai/speaking/result/batch`];
export const getWritingMachinePigai = ['get', `${apiUrl}/machine-pigai/writing/result/batch`];
export const postDuration = ['post', `${apiUrl}/exercises/duration`];
export const postListen = ['post', `${apiUrl}/listen-exercise`];
export const postListenComplete = ['post', `${apiUrl}/listen-exercises/complete`];
export const postListenReset = ['post', `${apiUrl}/listen-exercises/reset`];
export const getTelAttribution = ['post', `${getTelUrl}`];
export const getUserInfo = ['get', `${apiUrl}/users/get-user-base-info`];
export const setUserInfo = ['post', `${apiUrl}/users/user/profile`];
export const postRepeat = ['post', `${apiUrl}/speak-exercise`];
export const getRepeatDetail = ['get', `${apiUrl}/speak-exercises/detail`];
export const postRepeatAnswer = ['post', `${apiUrl}/speak-answer`];
export const postRepeatComplete = ['post', `${apiUrl}/speak-exercises/complete`];
export const getExamId = ['get', `${apiUrl}/exams/id`];
export const getPractice = ['get', `${apiUrl}/toefl/practice`];
export const getUserStatus = ['get', `${zhikeUrl}/api/user/status`];

// 测评中绑定 exerciseId 与 token
export const exerciseBelong = ['post', `${apiUrl}/exercise/belong`];

// 题库新接口， 开始练习和继续练习都需要修改
export const getTest = ['get', `${apiUrl}/exercises/test-detail`];
export const getPracticeNew = ['get', `${apiUrl}/exercises/practice-detail`];

// 动态获取站点logo
export const getLogo = ['get', `${apiUrl}/user/organization/logo`];



// WEBPACK FOOTER //
// ./src/common/apis.js